import { createAction } from '@ngrx/store';

export const emptyAction = createAction('[Forms] Action which does not trigger reducers or effects');
